import {localize} from "commons/LocalizedText/LocalizedText";
import {timestampToDate} from "utils/processing/dates";
import {productTestToPrioritize, RECOVER_UNIT_POSSIBILITY} from "components/ProductTest/ProductTestProjection";


export const mapProductRecords = (record) => {
  let orderForms = '';
  let labReports = '';
  let bills = '';
  record.orderFormProjections.forEach((orderForm, index) => {
    if(index !== 0){
      orderForms += ', '
    }
    orderForms += orderForm.name;
  });
  record.laboResultFiles.forEach((laboResultfile, index) => {
    if(index !== 0){
      labReports += ', '
    }
    labReports += laboResultfile.name;
  });
  record.billProjections.forEach((bill, index) => {
    if(index !== 0){
      bills += ', '
    }
    bills += bill.name;
  });
  return {
    company: record.companyName,
    productTestNumber: record.productTestNumber,
    program: record.programName,
    productType: record.productType,
    productName: record.productName,
    labOrderForms: orderForms,
    deliveryDeadline: timestampToDate(record.deadline),
    deliveryDate: timestampToDate(record.deliveryDate),
    scheduledTestDate: timestampToDate(record.scheduledTestDate),
    testDate: timestampToDate(record.testDate),
    labReports: labReports,
    bills: bills,
    partLab: record.partLab ? localize('yes') : localize('no'),
    toPrioritize: productTestToPrioritize(record.productTestTypeId, record.customerStatusId) ? localize('yes') : localize('no'),
    recoverUnit: record.recoverPossibilityProjection?.valueId === RECOVER_UNIT_POSSIBILITY.YES ? localize('yes') : localize('no')
  };
};